class MessageCardHandler {
  constructor(giftType) {
    if (!giftType) {
      throw new Error('Gift type must be specified');
    }

    this.giftType = giftType;
    this.ERROR_MESSAGES = {
      messageCard: 'メッセージカードの種類を選択してください',
      messageFont: '裏面メッセージのフォントを選択してください',
      messageText: 'メッセージを入力してください'
    };

    // 各gift_type固有のセレクタを定義
    this.selectors = {
      messageCard: `#gift-message-card-${this.giftType}`,
      messageConfirm: `#message-card-confirm-${this.giftType}`,
      messageBackside: `#message-backside-${this.giftType}`,
      messageFont: `#message-font-${this.giftType}`
    };

    this.initializeHandlers();
  }

  initializeHandlers() {
    this.initializeFontSelectionVisibility();
    this.handleMessageInput();
    this.handleMessageCardConfirmChange();
    this.setupErrorHandling();
  }

  initializeFontSelectionVisibility() {
    const $messageBackside = jQuery(this.selectors.messageBackside);
    const $fontSection = $messageBackside.closest('.gift-message-card').find('.gift-message-card__font');
    $fontSection.toggle($messageBackside.val().length > 0);
  }

  handleMessageInput() {
    jQuery(this.selectors.messageBackside).on('input', (e) => {
      const $fontSection = jQuery(e.target).closest('.gift-message-card').find('.gift-message-card__font');
      const hasMessage = e.target.value.length > 0;

      if (hasMessage) {
        $fontSection.slideDown('fast');
      } else {
        $fontSection.slideUp('fast');
        jQuery(this.selectors.messageFont)
          .val(null)
          .removeClass('error');
      }
    });
  }

  handleMessageCardConfirmChange() {
    jQuery(this.selectors.messageConfirm).on('change', (e) => {
      const $messageCard = jQuery(e.target).closest('.gift-message-card');
      const $messageText = jQuery(this.selectors.messageBackside);
      const $fontSection = $messageCard.find('.gift-message-card__font');
      const $messageFont = jQuery(this.selectors.messageFont);

      if (!e.target.checked) {
        $messageText.val('');
        $messageFont.val(null);
        $fontSection.hide();
      }
    });
  }

  setupErrorHandling() {
    // フォント選択のエラー状態クリア
    jQuery(this.selectors.messageFont).on('change', function () {
      jQuery(this).removeClass('error');
    });

    // メッセージ入力のエラー状態クリア
    jQuery(this.selectors.messageBackside).on('change', function () {
      jQuery(this).removeClass('error');
    });

    // メッセージカード種類選択のエラー状態クリア
    jQuery(`${this.selectors.messageCard} .gift-message-card__select [type="radio"]`).on('change', function () {
      jQuery(this).parent().parent().prev().removeClass('error');
    });
  }

  validateMessageCard() {
    const $messageCard = jQuery(this.selectors.messageCard);
    const hasMessageCardChecked = jQuery(this.selectors.messageConfirm).is(':checked');

    if (!hasMessageCardChecked) return true;

    const $messageCardSelect = $messageCard.find('[name="message-card-select"]:checked');
    if ($messageCardSelect.length === 0) {
      alert(this.ERROR_MESSAGES.messageCard);
      $messageCard.find('.gift-message-card__select').prev().addClass('error');
      return false;
    }

    return this.validateMessageAndFont();
  }

  validateMessageAndFont() {
    const $messageText = jQuery(this.selectors.messageBackside);
    const $messageFont = jQuery(this.selectors.messageFont);
    const hasMessage = $messageText.val().length > 0;

    if (!hasMessage) {
      $messageFont.removeClass('error');
      return true;
    }

    if (!$messageFont.val()) {
      alert(this.ERROR_MESSAGES.messageFont);
      $messageFont.addClass('error');
      return false;
    }

    return true;
  }

  getMessageCardProperties() {
    const hasMessageCard = jQuery(this.selectors.messageConfirm).is(':checked');

    if (!hasMessageCard) {
      return {
        messageCardConf: 'メッセージカード無し',
        messageCardVar: '',
        messageCardBack: '',
        messageCardFont: ''
      };
    }

    const $messageCard = jQuery(this.selectors.messageCard);

    return {
      messageCardConf: 'メッセージカード有り',
      messageCardVar: $messageCard.find('[name="message-card-select"]:checked').val(),
      messageCardBack: jQuery(this.selectors.messageBackside).val(),
      messageCardFont: jQuery(this.selectors.messageFont).val()
    };
  }
}

// グローバルに公開
window.MessageCardHandler = MessageCardHandler;